var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCelebrate = function SvgCelebrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.039 1.75s.183 1.07 0 2.057c-.197 1.063-1.03 2.057-1.03 2.057m2.575 2.57 1.03-1.028m1.854-2.828.464-1.285M20.22 7.92l1.03-.515m-3.09 3.6s.778.033 1.545.277c.69.221 1.545.751 1.545.751m-11.23-4.01 5.969 5.959a2.003 2.003 0 0 1-.685 3.282l-9.816 3.842c-1.627.637-3.233-.97-2.595-2.596L6.74 8.709a2.003 2.003 0 0 1 3.28-.685Z"
  })));
};
export default SvgCelebrate;